/// <amd-module name="VSSUI/Components/Time/Duration/Duration" />
import * as React from "react";
import * as DateUtil from "VSSUI/Utilities/Date";
import { IDurationProps } from "../Duration/Duration.Props";
import { Time } from "../Time/Time";
import * as Resources from "VSSUI/Resources.Widgets";
import { format } from "VSS/Core/Util/String";
import { ITooltipProps } from "VSSUI/TooltipEx";

export interface IDurationState {
    tooltipProps: ITooltipProps | null;
}

export class Duration extends React.Component<IDurationProps, IDurationState> {
    public static getDerivedStateFromProps(props: Readonly<IDurationProps>): Partial<IDurationState> {
        const tooltipProps =
            props.tooltipProps === undefined
                ? {
                      renderContent: function() {
                          return format(Resources.Started, DateUtil.tooltipString(props.startDate));
                      }
                  }
                : props.tooltipProps;
        return { tooltipProps: tooltipProps };
    }

    constructor(props: Readonly<IDurationProps>) {
        super(props);
        this.state = {
            tooltipProps: {}
        };
    }

    public render(): JSX.Element {
        return (
            <Time
                ariaHidden={this.props.ariaHidden}
                ariaLabel={this.props.ariaLabel ? this.props.ariaLabel : DateUtil.tooltipString(this.props.startDate)}
                className={this.props.className}
                getNextInterval={this.getNextInterval}
                getTimeString={this.getTimeString}
                tabIndex={this.props.tabIndex}
                tooltipProps={this.state.tooltipProps}
            />
        );
    }

    private getTimeString = (): string => {
        return DateUtil.duration(this.props.startDate, this.props.endDate);
    };

    /**
     * Returns time in milliseconds for next refresh.
     *
     * @return A number indicating time to refresh in milliseconds
     */
    private getNextInterval = (): number => {
        return Duration.durationNextInterval(this.props.startDate, this.props.endDate);
    };

    /**
     * Returns time in milliseconds for next refresh.
     *
     * @return A number indicating time to refresh in milliseconds
     */
    static durationNextInterval(startDate: Date, endDate?: Date, now?: Date): number {
        if (!endDate) {
            if (!now) {
                endDate = new Date();
            } else {
                endDate = now;
            }

            // Getting the difference in seconds between now and the specified date
            const diff = endDate.getTime() - startDate.getTime();

            let interval = DateUtil.minute;

            if (diff < DateUtil.day) {
                interval = DateUtil.second;
            } else {
                interval = DateUtil.minute - (diff % DateUtil.minute);
            }

            return interval;
        } else {
            return -1;
        }
    }
}
